import {formatearDecimal, formatearPorcentaje} from '../util/util';
import * as moment from 'moment';

export const percentage = {
    inserted(el, binding) {
        binding.value = isNaN(binding.value) ? 0 : binding.value;
        el.innerHTML = formatearPorcentaje(binding.value, 1) + "%";
    },
    update(el, binding) {
        binding.value = isNaN(binding.value) ? 0 : binding.value;
        el.innerHTML = formatearPorcentaje(binding.value, 1) + "%";
    }
};


export const valueDash = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML = binding.value;
        } else {
            el.innerHTML = "--"
        }

    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML = binding.value;
        } else {
            el.innerHTML = "--"
        }
    }
};

export const kms = {
    inserted(el, binding) {
        binding.value = isNaN(binding.value) ? 0 : binding.value;
        el.innerHTML = formatearDecimal(binding.value, 1) + " km";
    },
    update(el, binding) {
        binding.value = isNaN(binding.value) ? 0 : binding.value;
        el.innerHTML = formatearDecimal(binding.value, 1) + " km";
    }
};

export const duration = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML =  moment.utc( binding.value*1000).format('HH:mm');
        } else {
            el.innerHTML = "--"
        }
    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML =  moment.utc( binding.value*1000).format('HH:mm');
        } else {
            el.innerHTML = "--"
        }
    }
};




// WEBPACK FOOTER //
// ./src/directives/directives.js